<template>
  <div class="menu-wrapper">
    <div class="page-title">菜单管理</div>

    <div class="content-wrapper">
      <div class="content-left">
        <p class="sub-title">菜单列表</p>
        <menu-tree @handle-get-list="handleGetList" />
      </div>

      <div class="content-right">
        <p class="sub-title">资源点管理</p>
        <div class="page-buttons" style="padding-top: 10px; width: 350px">
          <crm-button
            v-if="auth.menuAdd && auth.menuAdd.toggleStatus"
            type="primary" 
            size="mini"
            @click="handleAddResource"
          >
            新增
          </crm-button>
          <el-input
            style="width: 250px; margin-left: 5px"  
            v-model="query" 
            placeholder="请输入权限名称或权限标识"
            size="mini"
            clearable
          >
            <el-button slot="append" icon="el-icon-search" @click="handleGetList(menuInfo, true)"></el-button>
          </el-input>
        </div>

        <Contents
          style="height: 100%"
          v-loading="loading"
          ref="tableRef"
          :table-data="list.results"
          :total="list.totalCount"
          @handle-page-change="handleGetList"
        >
         <template #default="{ row }">
            <el-button
              v-if="auth.menuUpdate && auth.menuUpdate.toggleStatus"
              type="text"
              @click="handleEdit(row)"
              :disabled="row.type === 1 ? true : false"
            >
              修改
            </el-button>
            <el-button
              v-if="auth.menuDelete && auth.menuDelete.toggleStatus"
              type="text"
              @click="handleDelete(row)"
              :disabled="row.type === 1 ? true : false"
            >删除</el-button>
          </template>
        </Contents>
      </div>
    </div>

    <resource-dialog ref="resourceRef" @handle-success="handleGetList(menuInfo)" />
  </div>
</template>

<script>
import MenuTree from '../components/MenuTree.vue'
import Contents from './Contents'
import ResourceDialog from './ResourceDialog'
import CrmButton from '@/components/base/crmButton'
import Services from '@/services/api/backstage'
import { mapGetters } from 'vuex';

export default {
  components: {
    MenuTree,
    ResourceDialog,
    CrmButton,
    Contents,
  },
  data() {
    return {
      loading: false,
      menuInfo: {},
      list: {},
      query: null,
    };
  },
  computed: {
    ...mapGetters({
      auth: 'authority/auth',
    }),
  },
  methods: {
    async handleGetList(val, isSearch = false) {
      if (val !== undefined) this.menuInfo = val
      try {
        this.loading = true
        const page = this.$refs.tableRef.page
        if (isSearch || val) page.pageNumber = 1
        const payload = { parentId: this.menuInfo.id, query: this.query, ...page }
        const { data } = await Services.apiQueryAuth(payload)
        this.list = data
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    handleEdit(row) {
      this.$refs.resourceRef.handleEdit(row)
    },
    handleDelete(row) {
      this.$confirm(`确定删除${row.name}权限？`).then(async () => {
        await Services.apiDeleteSystemTree({ id: row.id })
        this.$message.success('删除成功')
        this.handleGetList(this.menuInfo, true)
      })
    },
    handleAddResource() {
      this.$refs.resourceRef.handleOpen(this.menuInfo)
    },
  },
};
</script>

<style scoped lang="less">
@import '~@/styles/var.less';
@import '~@/styles/const.less';

.menu-wrapper {
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
  height: 100%;

  .page-title {
    height: 33px;
    margin-bottom: 10px;
    font-size: @font-size--max;
    color: @color--info;
    line-height: 33px;
    line-height: 33px;
  }
  .sub-title {
    position: relative;
    line-height: 40px;
    color: @color--info;
    font-size: 14px;
    padding-left: 20px;
    font-weight: 500;
    &::after {
      content: ' ';
      position: absolute;
      left: 5px;
      top: 12px;
      width: 5px;
      height: 15px;
      background-color: @color--link;
      border-radius: 4px;
    }
  }
  .content-wrapper {
    display: flex;
    flex: 1;

    .content-left {
      box-sizing: border-box;
      width: 230px;
      height: 100%;
      overflow: auto;
      background-color: @bg--white;
      box-shadow: @box-shadow;
      border-radius: 4px;
    }

    .content-right {
      position: relative;
      display: flex;
      flex-direction: column;
      flex: 1;
      background-color: @bg--white;
      margin-left: 20px;
      overflow: auto;
      box-shadow: @box-shadow;
      border-radius: 4px;
    }
  }
}
</style>
